
import {Component, Vue} from "vue-property-decorator";
import UserEditDialog from "../admin//UserEditDialog.vue"
import ConfirmDialog from "../ConfirmDialog.vue";
import {MdbsCore} from "@/api/tsclient";
import {currentUserModule, rolesModule, ntdUsersModule, usersModule} from "@/store";
import IUserUpdateDto = MdbsCore.IUserUpdateDto;
import IUserDto = MdbsCore.IUserDto;
import PersonDataDto = MdbsCore.PersonDataDto;
import UserUpdateDto = MdbsCore.UserUpdateDto;
import Rights = MdbsCore.Rights;
import IShortUserDto = MdbsCore.IShortUserDto;
import UserDto = MdbsCore.UserDto;

@Component({
  components: {
    UserEditDialog,
    ConfirmDialog
  },
})
export default class NtdUserTable extends Vue {
  search: string = "";

  toBeUpdatedItem: IUserUpdateDto | null = null;
  toBeUpdatedItemIsDeactivated = false;
  showUpdateDialog = false;
  toBeDeletedItem: IShortUserDto | null = new UserDto();
  showDeleteDialog = false;

  headers: any = [
    {text: 'Anzeigename', value: 'user.displayName'},
    {text: 'Benutzername', value: 'user.userName'},
    {text: 'Rolle', value: 'user.role.displayName'},
    {text: 'Email', value: 'user.email'},
    {text: 'Aktionen', value: 'actions', sortable: false, width: "120px", align: "center"}
  ];
  options: any = {
    sortBy: ['displayName'],
    sortDesc: [false]
  };

  get users() {
    return ntdUsersModule.ntdUsers;
  }

  get loading() {
    return ntdUsersModule.isLoading || rolesModule.isLoading;
  }

  get canEditUser() {
    return currentUserModule.hasRight(Rights.UserUpdateCmd);
  }

  get canDeleteUser() {
    return currentUserModule.hasRight(Rights.UserDeactivateCmd);
  }

  async mounted() {
    await ntdUsersModule.loadAll();
  }

  async updateUser(user: IUserDto) {
    await usersModule.getCompleteUserById(user.id);
    const completeUserById = usersModule.currentCompleteUser;

    this.toBeUpdatedItem = new UserUpdateDto({
      id: completeUserById.id,
      userName: completeUserById.userName ?? "",
      displayName: completeUserById.displayName ?? "",
      email: completeUserById.email ?? "",
      roleId: completeUserById.role?.id ?? "",
      personData: new PersonDataDto(completeUserById.personData),
    });
    this.toBeUpdatedItemIsDeactivated = completeUserById.isDeactivated ?? false;

    this.showUpdateDialog = true;
  }

  async deleteUser(user: IUserDto) {
    this.toBeDeletedItem = user;
    this.showDeleteDialog = true;
  }

  async handleDeleteUser() {
    if (this.toBeDeletedItem) {
      await usersModule.deleteUser(this.toBeDeletedItem.id);
    }

    this.showDeleteDialog = false;
  }

  async onSave() {
    this.showUpdateDialog = false;
    await ntdUsersModule.loadAll();
  }
}

